import { Grid } from "@mui/material";
import { Button } from "@mui/material";
import AgeFilterPills from "./AgeFilterPills";
import GenreFilterPills from "./GenreFilterPills";

function SortingFilter({ sortBy, setSortBy }) {
  function handleClick(event) {
    if (sortBy === "releaseDate") {
      setSortBy("viewCount");
    } else {
      setSortBy("releaseDate");
    }
  }
  return (
    <>
      <Button onClick={handleClick} size="small" variant="contained">
        {sortBy === "releaseDate" ? "Release Date" : "View Count"}
      </Button>
    </>
  );
}

function FilterPanel({
  sortBy,
  setSortBy,
  setAgeGroups,
  setGenreFilters,
  genreFilters,
  ageGroups,
}) {
  return (
    <Grid sx={{marginBottom:'40px'}} container rowSpacing={2} direction="column" justifyContent="center" alignItems="center">
      <Grid item xs={6}>
      <GenreFilterPills
        setGenreFilters={setGenreFilters}
        genreFilters={genreFilters}
      />
      </Grid>
      <Grid item xs={6}>
      <SortingFilter sortBy={sortBy} setSortBy={setSortBy} />
      </Grid>
      <Grid item xs={6}>
      <AgeFilterPills setAgeGroups={setAgeGroups} ageGroups={ageGroups} />
      </Grid>
    </Grid>
  );
}

export default FilterPanel;
